import React, { useEffect, forwardRef } from "react";
import { Formik, Field } from "formik";
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Select,
  notification,
  Collapse,
  Space,
  Table,
  Tag,
  Steps,
} from "antd";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { Switch } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import DocumentDetails from "./components/DocumentDetails";
import FinishGoods from "./components/FinishGoods";
import RawMaterial from "./components/RawMaterial";
import Routing from "./components/Routing";
import { injectReducer } from "../../../store";
import bomFormReducer from "./store";
import { getAllProduct } from "./store/dataSlice";

injectReducer("bom_form", bomFormReducer);

const BomForm = (props) => {
  const dispatch = useDispatch();
  const { initialData, onFormSubmit, onDiscard, type } = props;

  useEffect(() => {
    dispatch(getAllProduct());
  }, []);

  const finishGoods = useSelector((state) => state.bom_form.data.products);

  return (
    <>
      <div className="m-4 bg-white p-8 rounded-xl border-white">
        <Formik
          enableReinitialize
          initialValues={initialData}
          // validationSchema={validationSchema}
          onSubmit={(values, setSubmitting) => {
            onFormSubmit?.(values, setSubmitting);
          }}
        >
          {({
            values,
            touched,
            errors,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            resetForm,
          }) => (
            <Form>
              <Space direction="vertical">
                <Collapse
                  defaultActiveKey={["1"]}
                  size="large"
                  style={{ width: "1200px" }}
                  collapsible="icon"
                  items={[
                    {
                      key: "1",
                      label: "Document Details",
                      children: (
                        <DocumentDetails
                          values={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                        />
                      ),
                    },
                  ]}
                />

                <Collapse
                  collapsible="icon"
                  size="large"
                  items={[
                    {
                      key: "2",
                      label: "Finish Goods",
                      children: (
                        <>
                          <FinishGoods
                            values={values}
                            finishGoods={finishGoods}
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            resetForm={resetForm}
                          />
                        </>
                      ),
                    },
                  ]}
                />
                <Collapse
                  collapsible="icon"
                  size="large"
                  items={[
                    {
                      key: "3",
                      label: "Raw Material",
                      children: (
                        <RawMaterial
                          values={values}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                        />
                      ),
                    },
                  ]}
                />
                <Collapse
                  collapsible="icon"
                  size="large"
                  items={[
                    {
                      key: "4",
                      label: "Routing",
                      children: (
                        <Routing
                          values={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                        />
                      ),
                    },
                  ]}
                />
              </Space>

              <Row gutter={16}>
                {/* <Col span={8}>
                <Form.Item className="flex flex-col">
                  <span className="text-xs">Date of Joining</span>
                  <Field name="DOJ">
                    {({ field, form }) => (
                      <DatePicker
                        {...field}
                        value={field.value ? moment(field.value) : null}
                        onChange={(date, dateString) =>
                          form.setFieldValue("DOJ", dateString)
                        }
                        onBlur={form.handleBlur}
                        className="!rounded"
                        style={{ width: "100%", padding: "8px" }}
                      />
                    )}
                  </Field>
                </Form.Item>
              </Col> */}
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item className="flex justify-end">
                    <Button
                      // onClick={handleCancel}
                      type="primary"
                      className="mr-4"
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={isSubmitting}
                    >
                      Save
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};
export default BomForm;
